import { createContext, useContext } from 'react'

import { ComposerConfigContextType } from './@types/index.js'
import { DefaultExtensionConfig } from './config/constants.js'

export const ComposerConfigContext = createContext<ComposerConfigContextType>({
  extensions: DefaultExtensionConfig,
})

export const useComposerConfig = () => useContext(ComposerConfigContext)
